import WebGLPreLoader from 'mediamonks-webgl/renderer/core/WebGLPreLoader';
import IExample from './IExample';
import './main.css';

function handlePreloadComplete(webglManager: IExample) {
  webglManager.init();
}

/*let containerdiv = document.getElementById('preloader-container');
let progressdiv = document.getElementById('preloader-progress');*/

function handlePreloadProgress(progress: number) {
  /*  if (!containerdiv || !progressdiv) {
      throw new ReferenceError('Unable to find container divs in html');
    }
    containerdiv.style.display = progress < 1 ? 'block' : 'none';
    progressdiv.style.width = ((276 * progress) | 0) + 'px';*/
}


const preloader = new WebGLPreLoader();

const canvasContainer = document.createElement('div');
canvasContainer.classList.add('container');
document.body.appendChild(canvasContainer);
handlePreloadProgress(0);

// this module points to the target example using a webpack alias
import(
  /* webpackChunkName: "main" */
  'single-example'
  ).then(({default: ExampleModule}) => {
  let webglManager = new ExampleModule(canvasContainer, preloader, true);
  preloader.load(
    () => handlePreloadComplete(webglManager),
    handlePreloadProgress
  );
});

